import { render, staticRenderFns } from "./ViewMatchingDialog.vue?vue&type=template&id=48c95b66&scoped=true"
import script from "./ViewMatchingDialog.vue?vue&type=script&lang=js"
export * from "./ViewMatchingDialog.vue?vue&type=script&lang=js"
import style0 from "./ViewMatchingDialog.vue?vue&type=style&index=0&id=48c95b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c95b66",
  null
  
)

export default component.exports